export const EXAMPLE_BANNER_PROMPTS = [
  "Stwórz minimalistyczny banner na boże narodzenie z czerwono-złotą kolorystyką, elegancką typografią i kodem rabatowym SWIETA25 - 25% zniżki",
  "Zaprojektuj dramatyczny Black Friday banner z ciemnymi kolorami, neonowymi akcentami i dużym napisem 'MEGA WYPRZEDAŻ'",
  "Utwórz letni banner z tropikalnym tłem, palmami i napisem 'Wakacyjne okazje' - bez kodu rabatowego, focus na atmosferę",
  "Stwórz elegancki banner na Dzień Kobiet z kwiatowymi elementami, delikatnymi kolorami i kodem KOBIETY20",
  "Zaprojektuj nowoczesny back-to-school banner z geometrycznymi kształtami, żywymi kolorami i hasłem motywacyjnym",
  "Utwórz romantyczny banner na Walentynki z sercami, różowymi odcieniami i napisem o miłości - bez kodu promocyjnego",
  "Stwórz wiosenny banner z ilustracjami kwiatów, pastelowymi kolorami, ptakami i kodem WIOSNA30 na 30% taniej",
  "Zaprojektuj mroczny halloweenowy banner z dyniami, nietoperzami, pomarańczowo-czarnymi kolorami i atmosferą grozy",
  "Utwórz świąteczny banner noworoczny ze złotymi fajerwerkami, elegancką czcionką i napisem '2025 - nowy początek!'",
  "Stwórz wielkanocny banner z kolorowymi jajkami, królikami, wiosennymi kwiatami i kodem WIELKANOC15 - 15% rabatu",
];

export const getRandomPrompt = (): string => {
  const randomIndex = Math.floor(Math.random() * EXAMPLE_BANNER_PROMPTS.length);
  return EXAMPLE_BANNER_PROMPTS[randomIndex];
};

const PROMPT_HISTORY_KEY = "ai_banner_prompt_history";
const MAX_HISTORY_ITEMS = 10;

export interface PromptHistoryItem {
  prompt: string;
  timestamp: number;
}

export const savePromptToHistory = (prompt: string): void => {
  if (!prompt.trim()) return;

  const existingHistory = getPromptHistory();
  const newItem: PromptHistoryItem = {
    prompt: prompt.trim(),
    timestamp: Date.now(),
  };

  const filteredHistory = existingHistory.filter((item) => item.prompt !== prompt.trim());
  const updatedHistory = [newItem, ...filteredHistory].slice(0, MAX_HISTORY_ITEMS);

  localStorage.setItem(PROMPT_HISTORY_KEY, JSON.stringify(updatedHistory));
};

export const getPromptHistory = (): PromptHistoryItem[] => {
  try {
    const stored = localStorage.getItem(PROMPT_HISTORY_KEY);
    return stored ? JSON.parse(stored) : [];
  } catch {
    return [];
  }
};

export const clearPromptHistory = (): void => {
  localStorage.removeItem(PROMPT_HISTORY_KEY);
};
